var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"my-2 pa-4"},[_c('GChart',{key:_vm.currentUser.role,attrs:{"type":"Sankey","data":_vm.firstCameraIdData,"settings":_vm.sankeyChartSettings,"options":_vm.incidentCameraIdChartOptions}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }